import { trapFocus, removeTrapFocus } from '@shopify/theme-a11y'

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    customizeInstagramFeed()
  }, 18000)
})

const checkInstaFeedLoaded = () => {
  return new Promise((resolve, reject) => {
    const items = [...document.querySelectorAll('.eapps-instagram-feed-posts-item-link')]

    if (items.length > 0) {
      resolve(items);
    }
  });
}

const customizeInstagramFeed = () => {
  checkInstaFeedLoaded().then(items => {
    if (items) {
      items.forEach(item => {
        item.addEventListener('keydown', (e) => {
          if (e.keyCode === 13 || e.keyCode === 32) {
            setTimeout(() => {
              const popup = document.querySelector('.eapps-instagram-feed-popup-visible')
              const closeBtn = popup.querySelector('.es-popup-close')
              closeBtn.setAttribute('tabindex', '-1')
              closeBtn.setAttribute('role', 'button')
              closeBtn.setAttribute('aria-label', 'close')
              closeBtn.addEventListener('focusout', () => {
                closeBtn.setAttribute('tabindex', '0')
              })
              trapFocus(popup)
              closeBtn.focus()
              closeBtn.addEventListener('keydown', (e) => {
                if (e.keyCode === 13 || e.keyCode === 32) {
                  closeBtn.click()
                  removeTrapFocus()
                  item.focus()
                }
              })
            }, 500)
          }
        })
      })
    }
  }).catch(error => console.log(error))
}
